import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem('company_token'));
  const [companyName, setCompanyName] = useState(() => localStorage.getItem('company_name'));
  const [role, setRole] = useState(() => localStorage.getItem('company_role'));
  const [mustChangePassword, setMustChangePassword] = useState(
    () => localStorage.getItem('company_must_change_pw') === 'true'
  );

  const login = (tok, name, userRole, mustChange = false) => {
    localStorage.setItem('company_token', tok);
    localStorage.setItem('company_name', name);
    localStorage.setItem('company_role', userRole);
    localStorage.setItem('company_must_change_pw', mustChange ? 'true' : 'false');
    setToken(tok);
    setCompanyName(name);
    setRole(userRole);
    setMustChangePassword(mustChange);
  };

  const clearMustChangePassword = () => {
    localStorage.setItem('company_must_change_pw', 'false');
    setMustChangePassword(false);
  };

  const logout = () => {
    localStorage.removeItem('company_token');
    localStorage.removeItem('company_name');
    localStorage.removeItem('company_role');
    localStorage.removeItem('company_must_change_pw');
    setToken(null);
    setCompanyName(null);
    setRole(null);
    setMustChangePassword(false);
  };

  return (
    <AuthContext.Provider value={{ token, companyName, role, mustChangePassword, login, logout, clearMustChangePassword, isAuth: !!token }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
